// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Forge Casino — Slot Machine Page
// Routes to the correct slot game based on gameId
// ================================================================
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ClassicForge from '../games/slots/ClassicForge';
import ForgeRush from '../games/slots/ForgeRush';
import GoldenHammer from '../games/slots/GoldenHammer';

const GAMES = {
  'classic-forge': { component: ClassicForge, title: 'Classic Forge' },
  'forge-rush': { component: ForgeRush, title: 'Forge Rush' },
  'golden-hammer': { component: GoldenHammer, title: 'Golden Hammer' },
};

export default function SlotMachinePage() {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const game = GAMES[gameId];

  if (!game) {
    return (
      <div style={styles.notFound}>
        <h2 style={styles.notFoundTitle}>GAME NOT FOUND</h2>
        <p style={styles.notFoundText}>The slot machine "{gameId}" doesn't exist.</p>
        <button style={styles.backBtn} onClick={() => navigate('/slots')}>
          BACK TO SLOTS FLOOR
        </button>
      </div>
    );
  }

  const GameComponent = game.component;

  return (
    <div style={styles.container}>
      {/* Back navigation */}
      <div style={styles.nav}>
        <button style={styles.navBtn} onClick={() => navigate('/slots')}>
          ← SLOTS FLOOR
        </button>
        <button style={styles.navBtn} onClick={() => navigate('/lobby')}>
          LOBBY
        </button>
      </div>

      {/* Game */}
      <GameComponent />
    </div>
  );
}

const styles = {
  container: {
    padding: '12px',
    maxWidth: 600,
    margin: '0 auto',
    minHeight: '100vh',
    background: '#0a0a0a',
  },
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  navBtn: {
    padding: '6px 14px',
    borderRadius: 6,
    border: '1px solid #333',
    background: '#111',
    color: '#888',
    fontSize: 10,
    fontWeight: 700,
    letterSpacing: 1,
    cursor: 'pointer',
  },
  notFound: {
    textAlign: 'center',
    padding: '60px 20px',
    minHeight: '100vh',
    background: '#0a0a0a',
  },
  notFoundTitle: {
    fontSize: 24,
    color: '#DC2626',
    fontWeight: 900,
    letterSpacing: 3,
    marginBottom: 12,
  },
  notFoundText: {
    fontSize: 14,
    color: '#888',
    marginBottom: 24,
  },
  backBtn: {
    padding: '12px 24px',
    borderRadius: 8,
    border: '2px solid #DC2626',
    background: '#DC262622',
    color: '#DC2626',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 1,
    cursor: 'pointer',
  },
};
